import React from 'react';
import {
    ImageWrapper,
    ListItem,
    ItemImage,
    Wrapper,
    ItemText,
    DateText,
    AmountText,
    StatusText,
    ExpiredText,
    ExpiredLabel,
    BonusStatusText,
    DataWrapper,
    CommentText,
} from "../Wallet.style";
import {
    WITHDRAW_SK,
    BONUS_SK,
    SPIN_BONUS_SK,
} from "@constants";
import { getFormattedNumber, } from "@utils";
import { useTranslation } from "react-i18next";
import {
    BonusFilled,
    TrxBonusFilled
} from '@assets';
import moment from "moment";
import { getStatus } from "@utils";

const dateFormat = "DD MMM YYYY, hh:mm:ss A";

export const BonusImg = ({ type }) => (
    <ImageWrapper>
        {type === SPIN_BONUS_SK
            ? <BonusFilled />
            : <TrxBonusFilled />
        }
    </ImageWrapper>
);

const TransactionListItem = ({ item }) => {
    const { t } = useTranslation();

    return (
        <ListItem>
            <DataWrapper>
                <Wrapper>
                    {item.type === BONUS_SK
                        ? <BonusImg type={item.bonus_type} />
                        : <ItemImage src={item.payment_category_image} />
                    }
                    <ItemText>
                        {item.type === BONUS_SK
                            ? t("wallet.transactionHistoryBonusType", {
                                bonus_type: item.bonus_type,
                            })
                            : `${item.type === WITHDRAW_SK
                                ? t("wallet.walletWithdraw")
                                : t("wallet.walletTopUp")
                            } ${t("common.to")} ${item.num}`}
                    </ItemText>
                    <AmountText>
                        {`${getFormattedNumber(item.amount)}`}
                    </AmountText>
                </Wrapper>
                <Wrapper>
                    <DateText style={{ flex: 1 }}>
                        {moment.unix(item.created_at).format(dateFormat)}
                    </DateText>
                    {item.type === BONUS_SK && item.bonus_expired && (
                        <BonusStatusText status={item.status}>
                            {item.status === 'Used'
                                ? t("wallet.bonusUsedText")
                                : t("wallet.bonusNotUsedText")
                            }
                        </BonusStatusText>
                    )}
                    {item.type !== BONUS_SK && (
                        <StatusText status={item.status}>
                            {getStatus(item.status)}
                        </StatusText>
                    )}
                </Wrapper>
                <Wrapper>
                    {item.trx_num &&
                        <DateText>
                            <ExpiredLabel>PIN</ExpiredLabel> {`${item.trx_num}`}
                        </DateText>
                    }
                     {item.comment &&
                        <CommentText>
                            {item.comment}
                        </CommentText>
                    }
                    {item.type === BONUS_SK && item.bonus_expired &&
                        <div style={{ display: "flex" }}>
                            <ExpiredLabel>{t("wallet.expiredLabel")}</ExpiredLabel>
                            <ExpiredText>&nbsp;&nbsp;
                                {moment.unix(item.bonus_expired).format(dateFormat)}
                            </ExpiredText>
                        </div>
                    }
                </Wrapper>
            </DataWrapper>

        </ListItem>
    );
}

export default TransactionListItem;